module.exports = __webpack_public_path__ + "img/bus_title_img_2.c4171a44.svg";